export default Object.freeze({
  Therapy: 3,
  Assistant: 4,
});
